const COUNTRY_ALIAS_TO_ISO2: Record<string, string> = {
  FR: 'FR',
  FRA: 'FR',
  FRANCE: 'FR',
  IT: 'IT',
  ITA: 'IT',
  ITALY: 'IT',
  ITALIE: 'IT',
  ITALIA: 'IT',
  ES: 'ES',
  ESP: 'ES',
  SPAIN: 'ES',
  ESPAGNE: 'ES',
  ESPANA: 'ES',
  DE: 'DE',
  DEU: 'DE',
  GERMANY: 'DE',
  ALLEMAGNE: 'DE',
  DEUTSCHLAND: 'DE',
  BE: 'BE',
  BEL: 'BE',
  BELGIUM: 'BE',
  BELGIQUE: 'BE',
  CH: 'CH',
  CHE: 'CH',
  SWITZERLAND: 'CH',
  SUISSE: 'CH',
  NL: 'NL',
  NLD: 'NL',
  NETHERLANDS: 'NL',
  PAYSBAS: 'NL',
  HOLLAND: 'NL',
  LU: 'LU',
  LUX: 'LU',
  LUXEMBOURG: 'LU',
  PT: 'PT',
  PRT: 'PT',
  PORTUGAL: 'PT',
  GB: 'GB',
  GBR: 'GB',
  UK: 'GB',
  UNITEDKINGDOM: 'GB',
  ROYAUMEUNI: 'GB',
  GREATBRITAIN: 'GB',
  IE: 'IE',
  IRL: 'IE',
  IRELAND: 'IE',
  IRLANDE: 'IE',
  AT: 'AT',
  AUT: 'AT',
  AUSTRIA: 'AT',
  AUTRICHE: 'AT',
  PL: 'PL',
  POL: 'PL',
  POLAND: 'PL',
  POLOGNE: 'PL',
  CZ: 'CZ',
  CZE: 'CZ',
  CZECHREPUBLIC: 'CZ',
  TCHEQUIE: 'CZ',
  HU: 'HU',
  HUN: 'HU',
  HUNGARY: 'HU',
  HONGRIE: 'HU',
  RO: 'RO',
  ROU: 'RO',
  ROMANIA: 'RO',
  ROUMANIE: 'RO',
  GR: 'GR',
  GRC: 'GR',
  GREECE: 'GR',
  GRECE: 'GR',
  DK: 'DK',
  DNK: 'DK',
  DENMARK: 'DK',
  DANEMARK: 'DK',
  SE: 'SE',
  SWE: 'SE',
  SWEDEN: 'SE',
  SUEDE: 'SE',
  NO: 'NO',
  NOR: 'NO',
  NORWAY: 'NO',
  NORVEGE: 'NO',
  FI: 'FI',
  FIN: 'FI',
  FINLAND: 'FI',
  FINLANDE: 'FI',
  US: 'US',
  USA: 'US',
  UNITEDSTATES: 'US',
  ETATSUNIS: 'US',
  CA: 'CA',
  CAN: 'CA',
  CANADA: 'CA',
  MX: 'MX',
  MEX: 'MX',
  MEXICO: 'MX',
  MEXIQUE: 'MX',
  BR: 'BR',
  BRA: 'BR',
  BRAZIL: 'BR',
  BRESIL: 'BR',
  AE: 'AE',
  ARE: 'AE',
  UNITEDARABEMIRATES: 'AE',
  EMIRATSARABESUNIS: 'AE',
  SA: 'SA',
  SAU: 'SA',
  SAUDIARABIA: 'SA',
  SG: 'SG',
  SGP: 'SG',
  SINGAPORE: 'SG',
  SINGAPOUR: 'SG',
  JP: 'JP',
  JPN: 'JP',
  JAPAN: 'JP',
  JAPON: 'JP',
  CN: 'CN',
  CHN: 'CN',
  CHINA: 'CN',
  CHINE: 'CN',
  KR: 'KR',
  KOR: 'KR',
  SOUTHKOREA: 'KR',
  COREE: 'KR',
  IN: 'IN',
  IND: 'IN',
  INDIA: 'IN',
  INDE: 'IN',
  AU: 'AU',
  AUS: 'AU',
  AUSTRALIA: 'AU',
  AUSTRALIE: 'AU',
  NZ: 'NZ',
  NZL: 'NZ',
  NEWZEALAND: 'NZ',
  RUS: 'RU',
  RU: 'RU',
  RUSSIA: 'RU',
  RUSSIE: 'RU',
  TR: 'TR',
  TUR: 'TR',
  TURKEY: 'TR',
  TURQUIE: 'TR',
  HK: 'HK',
  HKG: 'HK',
  HONGKONG: 'HK',
  TW: 'TW',
  TWN: 'TW',
  TAIWAN: 'TW',
  IL: 'IL',
  ISR: 'IL',
  ISRAEL: 'IL',
  MA: 'MA',
  MAR: 'MA',
  MOROCCO: 'MA',
  MAROC: 'MA',
  MC: 'MC',
  MCO: 'MC',
  MONACO: 'MC',
};

const ISO2_CODES = new Set(Object.values(COUNTRY_ALIAS_TO_ISO2));

function normalizeCountryAlias(raw: string): string {
  return raw
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/[^A-Z]/g, '');
}

function resolveCountryToken(rawToken: string): string | null {
  const token = rawToken.trim().toUpperCase();
  if (!token) return null;
  if (/^[A-Z]{2}$/.test(token) && ISO2_CODES.has(token)) return token;

  const normalized = normalizeCountryAlias(token);
  if (!normalized) return null;

  const mapped = COUNTRY_ALIAS_TO_ISO2[normalized];
  if (mapped) return mapped;

  return null;
}

// ISO 3166-1 numeric -> alpha-2. Keyed on the `id` carried by world-atlas topojson country
// features, which is the numeric code as a string.
const ISO_NUMERIC_TO_ISO2: Record<string, string> = {
  '250': 'FR', '840': 'US', '826': 'GB', '276': 'DE', '380': 'IT', '724': 'ES',
  '056': 'BE', '756': 'CH', '528': 'NL', '040': 'AT', '620': 'PT', '372': 'IE',
  '124': 'CA', '156': 'CN', '392': 'JP', '036': 'AU', '076': 'BR', '356': 'IN',
  '643': 'RU', '710': 'ZA', '484': 'MX', '410': 'KR', '792': 'TR', '682': 'SA',
  '784': 'AE', '702': 'SG', '344': 'HK', '752': 'SE', '578': 'NO', '208': 'DK',
  '246': 'FI', '616': 'PL', '203': 'CZ', '348': 'HU', '300': 'GR',
};

/** Resolves a topojson country feature id (ISO numeric) into its ISO alpha-2 code. */
export function isoNumericToCountryCode(featureId: unknown): string | null {
  return ISO_NUMERIC_TO_ISO2[String(featureId ?? '').padStart(3, '0')] ?? null;
}

export function toIsoCountryCodes(raw: unknown): string[] {
  if (typeof raw !== 'string') return [];
  const value = raw.trim();
  if (!value) return [];

  const tokens = value
    .split(/[,\|;\/()\[\]]+/g)
    .map((token) => token.trim())
    .filter((token) => token.length > 0);

  const parsedTokens = tokens.length > 0 ? tokens : [value];
  const codes = new Set<string>();

  for (const token of parsedTokens) {
    const code = resolveCountryToken(token);
    if (code) codes.add(code);
  }

  return Array.from(codes).sort();
}
